import Component from '../abstracts/Component';
import TrackingComponent from "./TrackingComponent";

export default class InfiniteScrollTextComponent extends Component {

  get COMPONENTNAME() {
    return 'InfiniteScrollTextComponent';
  }

  get SELECTORS() {
    return {
      scrollContent: '#infinite-scroll-container .stage_animation',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.scrollContent = this.$component.querySelector('#infinite-scroll-container .stage_animation');
  }


  initScroll() {
    const ctx = this;
    // Clone the content
    ctx.scrollContent.innerHTML += ctx.scrollContent.innerHTML;

    let scrollSpeed = 2; // Speed in pixels per frame
    let position = 0;

    function smoothScroll() {
      position -= scrollSpeed; // Move left

      // Reset position when fully scrolled past
      if (Math.abs(position) >= ctx.scrollContent.clientWidth / 2) {
        position = 0;
      }

      ctx.scrollContent.style.transform = `translateX(${position}px)`;

      requestAnimationFrame(smoothScroll); // smooth animation
    }

    // Start the scrolling
    smoothScroll();
  }

  render() {
    super.render();
    this.initScroll();
  }
}
